import CanBeAttacked from "./CanBeAttacked";
import CanBeSpawned from "./CanBeSpawned";
import CanSpawn from "./CanSpawn";
import CanWalk from "./CanWalk";
import CanFly from "./CanFly";
import HasHealth from "./HasHealth";
import HasShadow from "./HasShadow";
import HasDestructionParticles from "./HasDestructionParticles";
import HasDestructionScreenShake from "./HasDestructionScreenShake";
import HasDamagingInterval from "./HasDamagingInterval";
import IsImmovable from "./IsImmovable";

// Effects
import HasEffects from "./effects/HasEffects.js";
import HasDamageEffect from "./effects/HasDamageEffect.js";

export default {
  CanBeAttacked,
  CanBeSpawned,
  CanFly,
  CanSpawn,
  CanWalk,
  HasHealth,
  HasShadow,
  HasDestructionParticles,
  HasDestructionScreenShake,
  HasDamagingInterval,
  IsImmovable,

  // Effects
  HasEffects,
  HasDamageEffect
};
